module.exports = __webpack_public_path__ + "img/item5-2.ab9e499e.jpg";